/**
 * デバッグ用のエラーダイアログ表示が有効かを判定する
 *
 * システムエラーダイアログの見た目を確認するためのもので、実際のエラーは発生させない。
 * VITE_DEBUG_ERROR_DIALOG=1 の環境で、URLに ?debugErrorDialog=1 が付いている場合のみ有効。
 * 本番環境の .env には VITE_DEBUG_ERROR_DIALOG を定義しない。
 */
export const isDebugErrorDialogEnabled = (): boolean => {
  if (import.meta.env.VITE_DEBUG_ERROR_DIALOG !== '1') return false;
  if (typeof window === 'undefined') return false;

  return new URLSearchParams(window.location.search).get('debugErrorDialog') === '1';
};
